import React from 'react'
import { StyleToolbar } from './StyleToolbar'
import { LinkToolbar } from './LinkToolbar'
import { LinkEditToolbar } from './LinkEditToolbar'
import { RichUtils } from 'draft-js'
import { selectionIsLink, getSelectedLinkUrl } from 'lib/draftUtils'
import * as blockUtils from 'lib/blockUtils'

export const LINK_TOOLBAR = 'LINK_TOOLBAR'
export const LINK_EDIT_TOOLBAR = 'LINK_EDIT_TOOLBAR'

export class InlineToolbar extends React.Component {
  constructor (props) {
    super(props)
    this.state = { activeToolbar: null }
  }

  resetState = () => {
    this.setState({ activeToolbar: null })
  }

  showLinkToolbar = () => {
    this.props.freezeSelection()
    this.setState({ activeToolbar: LINK_TOOLBAR })
  }

  dismissLinkToolbar = () => {
    this.props.unfreezeSelection()
    this.setState({ activeToolbar: null })
    this.props.restoreFocus()
  }

  removeLink = () => {
    const { editorState, onChange } = this.props
    const selection = editorState.getSelection()
    if (!selection.isCollapsed()) {
      onChange(RichUtils.toggleLink(editorState, selection, null))
    }
  }

  render () {
    const { position, editorState, selectionIsFrozen } = this.props
    if (!editorState.getSelection().hasFocus && !selectionIsFrozen) {
      return null
    }
    const currentBlockType = RichUtils.getCurrentBlockType(editorState)
    if (!['unstyled', 'unordered-list-item', 'ordered-list-item'].includes(currentBlockType)) {
      return null
    }
    // don't show the toolbar unless the selection exclusively has supported blocktypes
    const contentState = editorState.getCurrentContent()
    const selectedBlocks = blockUtils.selectedBlocks(contentState, editorState.getSelection())
    if (selectedBlocks.filterNot(x => (
      ['unstyled', 'unordered-list-item', 'ordered-list-item'].includes(x.type)
    )).count() > 0) {
      return null
    }

    const { activeToolbar } = this.state
    const height = 40
    const arrowHeight = 8
    const style = {
      height,
      position: 'absolute',
      top: position.top - height - arrowHeight,
      left: position.left
    }

    switch (activeToolbar) {
      case LINK_TOOLBAR:
        return <LinkToolbar {...this.props} placeholderUrl={getSelectedLinkUrl(editorState) || 'http://www.ridewithgps.com'} style={style} onDismiss={this.dismissLinkToolbar} />
      default:
        if (selectionIsLink(editorState) && editorState.getSelection().isCollapsed()) {
          return <LinkEditToolbar {...this.props} style={style} onEditLink={this.showLinkToolbar} />
        } else {
          return <StyleToolbar {...this.props} style={style} onAddLink={this.showLinkToolbar} onRemoveLink={this.removeLink} />
        }
    }
  }
}

// Link toolbar notes:

// Google's version
// 1. uses cmd+k as the hotkey
// 2. loses focus when you click outside of it
// 3. box with preview/edit/remove on cursor over

// Medium's version
// 1. way more minimal - type link, hit enter
// 2. only way to edit the link is to remove the whole thing and re-do
// 3. tooltip on mouseover to preview

// Facebook's version
// 1. sucks - super buggy
// 2. takes input cues from Medium's version
// 3. you can remove the link by selecting the text and toggling the entity, but
//    there's no way to edit it after the fact
